import { FC, useEffect } from 'react'
import { RadioGroup } from 'entities/RadioGroup'
import { useConfigStore } from 'shared/store/configSlice'
import { radioFontOptions } from './options'

export const FontHandler: FC<FontHandlerType> = ({ font, updateFontHandler }) => {
  const isConfigLoaded = useConfigStore().isConfigLoaded

  useEffect(() => {
    if (!font && isConfigLoaded) {
      updateFont(radioFontOptions?.[0]?.value)
    }
  }, [font, isConfigLoaded])

  const updateFont = (value: string) => {
    updateFontHandler({ font: value })
  }

  return (
    <RadioGroup
      key={`font_picker_${font}`}
      options={radioFontOptions}
      value={font}
      handleChange={updateFont}
      title='Font selcetion'
      sx={{
        width: '720px',
        display: 'grid',
        gap: '10px',
        gridTemplateColumns: 'repeat(auto-fill, 233px)'
      }}
    />
  )
}

type FontHandlerType = {
  font: string
  updateFontHandler: (value: { font: string }) => void
}
